const PromotionEffectType = {
  AUTOMATIC_DISCOUNT: "automatic_discount",
  BUY_X_GET_Y: "buy_x_get_y"
};

export { PromotionEffectType as P };
